<template>
  <!-- 是否可输入
       @author: 王汝鹏
       @date: 2019-9-10
   -->
  <div class="setting-item">
    <el-form-item label="是否可输入"> 
      <el-switch v-model="isEditable"></el-switch>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 是否可输入
     *  @description 将 isEditable 字段映射到当前 isEditable 计算属性
     *  @author 王汝鹏
     *  @version 2019-09-15
     */
    ...mapComputed({
      isEditable: { 
        parent: i => i.baseOption,
        attr: "isEditable" 
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingIsEditable.vue